"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function default_1({ startDateUnixTimestamp, endDateUnixTimestamp, serverTime, closeSales, refreshServerTime, startDeltaRemaining, countdownMounted, DELTA_DIFF_LIMIT, }) {
    const FIVE_MIN = 300000; // ms
    const ONE_MIN = 60000; // ms
    const SIX_MIN = FIVE_MIN + ONE_MIN;
    const THIRTY_SEC = 30000; // ms
    const THIRTY_SEC_MINUS_RANDOM = THIRTY_SEC - Math.round(Math.random() * 1000); // ? 30000~29000 ms
    const TEN_SEC = 10000; // ms
    const FOURTY_SEC = THIRTY_SEC + TEN_SEC;
    const FIVE_SEC = 5000; // ms
    const FIVE_SEC_AROUND_RANDOM = // ? 4500~5500 ms
     FIVE_SEC + Math.round(Math.random() * 500) * (Math.round(Math.random()) ? 1 : -1);
    const fiveMinRefreshTimer = (0, react_1.useRef)(0);
    const thirtySecRefreshTimer = (0, react_1.useRef)(0);
    const fiveSecRefreshTimer = (0, react_1.useRef)(0);
    const salesClosingTimer = (0, react_1.useRef)(0);
    const calcStartEndTime = () => {
        const componentMountedTime = new Date().getTime();
        const startTimeRemaining = startDateUnixTimestamp - serverTime;
        startDeltaRemaining.current = startTimeRemaining > -DELTA_DIFF_LIMIT ? startTimeRemaining : 0; // ? 0.1ms 오차를 고려함
        const adjustedStartTime = componentMountedTime + startTimeRemaining;
        const endTimeLeft = Math.min(endDateUnixTimestamp - serverTime, Math.pow(2, 30) // ? 약 12.4일, setTimeout의 최대 허용 ms -> 2^31 - 1 (약 24.8일)
        );
        const endTimeRemaining = endTimeLeft > 0 ? endTimeLeft : 0;
        return { adjustedStartTime, endTimeRemaining };
    };
    const [startTime, setStartTime] = (0, react_1.useState)(startDateUnixTimestamp);
    (0, react_1.useEffect)(() => {
        if (serverTime && countdownMounted) {
            const { adjustedStartTime, endTimeRemaining } = calcStartEndTime(); // ! also assigns startDeltaRemaining.current
            setStartTime(adjustedStartTime);
            if (endTimeRemaining) {
                salesClosingTimer.current = window.setTimeout(closeSales, endTimeRemaining);
            }
            else {
                closeSales();
            }
            const deltaRemaining = startDeltaRemaining.current;
            if (deltaRemaining > 0) {
                if (deltaRemaining > SIX_MIN) {
                    fiveMinRefreshTimer.current = window.setTimeout(refreshServerTime, FIVE_MIN);
                }
                else if (deltaRemaining > FOURTY_SEC) {
                    let delayToThirtySec = deltaRemaining - THIRTY_SEC_MINUS_RANDOM;
                    thirtySecRefreshTimer.current = window.setTimeout(refreshServerTime, delayToThirtySec);
                }
                else if (deltaRemaining > TEN_SEC) {
                    let delayToFiveSec = deltaRemaining - FIVE_SEC_AROUND_RANDOM;
                    fiveSecRefreshTimer.current = window.setTimeout(refreshServerTime, delayToFiveSec);
                }
            }
        }
        return () => {
            window.clearTimeout(fiveMinRefreshTimer.current);
            window.clearTimeout(thirtySecRefreshTimer.current);
            window.clearTimeout(fiveSecRefreshTimer.current);
            window.clearTimeout(salesClosingTimer.current);
        };
    }, [serverTime]);
    return startTime;
}
exports.default = default_1;
